import { FC } from "react";
import Button from "./Button";
import Typography from "./Typography";

type VideoSelectionControlsProps = {
  selectedCount: number;
  totalCount: number;
  areAllSelected: boolean;
  onToggleAll: () => void;
  disabled?: boolean;
  containerClassName: string;
  buttonClassName?: string;
  /** The "N selected" caption. Mobile hides it: the count is the title there. */
  countClassName?: string;
};

const VideoSelectionControls: FC<VideoSelectionControlsProps> = ({
  selectedCount,
  totalCount,
  areAllSelected,
  onToggleAll,
  disabled = false,
  containerClassName,
  buttonClassName,
  countClassName = "",
}) => {
  return (
    <div className={containerClassName}>
      {selectedCount > 0 && (
        <Typography
          variant="caption"
          className={`text-foreground-muted text-right ${countClassName}`}
        >
          {`${selectedCount} selected`}
        </Typography>
      )}
      <Button
        className={buttonClassName}
        variant="tertiary"
        size="m"
        onClick={onToggleAll}
        disabled={disabled}
      >
        {areAllSelected ? "Deselect all" : `Select all (${totalCount})`}
      </Button>
    </div>
  );
};

export default VideoSelectionControls;
